<template>
  <card :title="title" bodyPadding="10px 15px">
    <div class="weui-uploader-folder__bd">
      <ul class="weui-uploader-folder__files" id="uploaderFiles">
        <li
          v-for="(image, index) in images"
          :key="index"
          class="weui-uploader-folder__file"
          :style="{
            'background-image': `url(${image}?&x-oss-process=image/resize,m_fill,h_90,w_90)`
          }"
          @click="show(index)"
        ></li>
      </ul>
      <div v-transfer-dom>
        <previewer :list="list" ref="previewer" :options="options"></previewer>
      </div>
    </div>
  </card>
</template>

<script>
import { Previewer, TransferDom } from "vux";
import Card from "./Card";

export default {
  directives: { TransferDom },
  components: { Previewer, Card },
  props: {
    title: {
      type: String
    },
    images: {
      type: Array
    }
  },
  created() {
    this.options = {
      getThumbBoundsFn: index => {
        // find thumbnail element
        let thumbnail = this.$el.querySelectorAll(
          ".weui-uploader-folder__file"
        )[index];
        // get window scroll Y
        let pageYScroll =
          window.pageYOffset || document.documentElement.scrollTop;
        // optionally get horizontal scroll
        // get position of element relative to viewport
        let rect = thumbnail.getBoundingClientRect();
        // w = width
        return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        // Good guide on how to get element coordinates:
        // http://javascript.info/tutorial/coordinates
      }
    };
  },
  computed: {
    list() {
      return this.images.map(url => {
        return { src: url };
      });
    }
  },
  methods: {
    show(index) {
      this.$refs.previewer.show(index);
    }
  }
};
</script>

<style lang="less">
@import "~vux/src/styles/weui/widget/weui-uploader/index.less";
.weui-uploader-folder {
  &__bd {
    display: flex;
  }
  &__files {
    list-style: none;
    display: flex;
    flex-flow: wrap;
  }
  &__input-box {
    position: relative;
    margin-right: 9px;
    width: 90px;
    height: 90px;
  }
  &-icon {
    text-align: center;
    .icon {
      font-size: 25px;
    }
  }
  &-text {
    font-size: 12px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(145, 145, 145, 1);
  }
  &__container {
    height: 90px;
    width: 90px;
    border: 1px dashed rgba(226, 226, 226, 1);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__file {
    margin-right: 9px;
    margin-bottom: 9px;
    width: 90px;
    height: 90px;
    background: no-repeat center center;
    background-size: cover;
    position: relative;
    &-close {
      position: absolute;
      right: 0;
      top: 0;
      color: red;
    }
  }
}
</style>
